<script lang="ts">
	import { t } from 'svelte-i18n';
	import { ButtonBoxPrimary } from '@wiseed/wikit';
	import { Countdown } from '@wiseed/wikit';
	import {
		formatDateTimeWithLocale,
		getEstimatedDateText,
		type wikitDuration
	} from '@wiseed/wikit';
	import { SVG } from '@wiseed/wikit';
	import { getOperation } from '@app/services/api/operations';
	import { isOperationUpdated, operationStore } from '@app/stores/operation';
	import type { LiveModel } from '@app/models/api/LiveModel';
	import type { OperationModel } from '@app/models/api/OperationModel';
	import { page } from '$app/stores';
	import ButtonInvest from '@app/components/ButtonInvest.svelte';
	import { bottomNavbarHeight } from '@app/stores/bottomNavbar';
	import { onMount } from 'svelte';
	import { getOperationCollectStatus } from '@app/utils/operations';

	export let operation: OperationModel;
	export let live: LiveModel;
	export let walletOk: boolean;
	export let openModal: () => void;

	let isWalletOk: boolean;
	let countDownStartCollecte: boolean;
	let countDownEndCollecte: boolean;
	let printCountdownBlock: boolean;
	let startDate: string | undefined;
	let endDate: string | undefined;
	let dateStartCollect: Date | undefined;
	let dateEndCollect: Date | undefined;
	let collectStarted: boolean | undefined;
	let collectEnded: boolean | undefined;
	let liveId: number | undefined;
	let operationId: string | undefined;
	let estimatedEndDateCollect: Date | null;
	let duration: wikitDuration;

	$: ({
		isWalletOk,
		operationId,
		liveId,
		startDate,
		endDate,
		dateStartCollect,
		dateEndCollect,
		collectStarted,
		collectEnded,
		printCountdownBlock
	} = getOperationCollectStatus({ walletOk, operation, live }));

	onMount(() => {
		countDownStartCollecte = dateStartCollect != null && !collectStarted;
		countDownEndCollecte =
			(collectStarted || startDate === undefined) && dateEndCollect !== null && !collectEnded;
	});
</script>

<div class="space-y-4 text-center xl:space-y-0 xl:grid xl:grid-cols-2 xl:items-center xl:gap-4">
	{#if operation && !(countDownStartCollecte && isWalletOk)}
		<div
			class="!fixed z-10 w-full lg:w-auto left-0 lg:!relative lg:!bottom-auto"
			style={`bottom: ${$bottomNavbarHeight}px`}
		>
			<ButtonInvest
				{operation}
				props={{ classNames: ' justify-center w-full lg:w-auto !rounded-none lg:!rounded-lg' }}
			/>
		</div>
	{/if}
	{#if $page.data.user && printCountdownBlock}
		{#if (countDownStartCollecte && isWalletOk) || (live && isWalletOk)}
			<div class="text-center xl:text-left">
				<ButtonBoxPrimary
					props={{ label: $t('operation.alertSMS'), iconRight: 'chat' }}
					on:click={() => openModal()}
				/>
			</div>
		{/if}
		<div class="flex flex-col justify-center xl:justify-start gap-3">
			<div class="flex items-center justify-center gap-4 xl:gap-3 2xl:gap-5">
				{#if countDownStartCollecte && startDate}
					<SVG name="timer" size="big" />
					<Countdown
						bind:duration
						monthsLabel={$t('duration.months', { values: { n: duration?.months } })}
						daysLabel={$t('duration.days', { values: { n: duration?.days } })}
						hoursLabel={$t('duration.hours', { values: { n: duration?.hours } })}
						minutesLabel={$t('duration.minutes', { values: { n: duration?.minutes } })}
						secondsLabel={$t('duration.seconds', { values: { n: duration?.seconds } })}
						endDateString={startDate}
						whenCountdownEnds={() => {
							setTimeout(async () => {
								if (operationId) {
									$operationStore = await getOperation(operationId);
									$isOperationUpdated = true;
									countDownStartCollecte = false;
								}
							}, 1000);
						}}
					/>
				{/if}
				{#if countDownEndCollecte && endDate}
					<div class="text-danger">
						<SVG name="timer" size="big" />
					</div>
					<Countdown
						bind:duration
						monthsLabel={$t('duration.months', { values: { n: duration?.months } })}
						daysLabel={$t('duration.days', { values: { n: duration?.days } })}
						hoursLabel={$t('duration.hours', { values: { n: duration?.hours } })}
						minutesLabel={$t('duration.minutes', { values: { n: duration?.minutes } })}
						secondsLabel={$t('duration.seconds', { values: { n: duration?.seconds } })}
						endDateString={endDate}
						whenCountdownEnds={() => {
							countDownEndCollecte = false;
						}}
					/>
				{/if}
				{#if estimatedEndDateCollect && !countDownEndCollecte && !countDownStartCollecte}
					<p class="text-xl font-bold">{$t('operation.messages.ongoingCollect')}</p>
				{/if}
			</div>

			<p class="text-center text-sm xl:text-xs 2xl:text-sm">
				{#if !liveId}
					{#if countDownStartCollecte && startDate}
						{@html $t('operation.messages.openingDay', {
							values: { dateOpening: formatDateTimeWithLocale(startDate) }
						})}
					{:else if countDownEndCollecte && endDate}
						<span class="text-danger">
							{@html $t('operation.messages.endingDay', {
								values: { dateEnding: formatDateTimeWithLocale(endDate) }
							})}
						</span>
					{:else if estimatedEndDateCollect}
						<p>
							{$t('operation.messages.estimatedClosing')}
							{getEstimatedDateText(estimatedEndDateCollect)}
						</p>
					{/if}
				{/if}
			</p>
		</div>
	{/if}
</div>
